import React from "react";
import { observer } from "mobx-react-lite";
import { Col, Form, Row } from "react-bootstrap";
import type { ViewComponent } from "@frui.ts/views";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import { formatAmount, formatDateTime } from "utils/localizations";
import type PayGateRefundDetailViewModel from "viewModels/finance/refundApprovals/payGateRefunds/payGateRefundDetailViewModel";
import type PayGateToTransferRefundDetailViewModel from "viewModels/finance/refundApprovals/payGateToTransferRefunds/payGateToTransferRefundDetailViewModel";
import Section from "../../../common/section";
import { refundPaymentProcessingInfo } from "../payGateRefunds/payGateRefundsView";

const PayGateRefundPaymentSectionView: ViewComponent<PayGateRefundDetailViewModel | PayGateToTransferRefundDetailViewModel> =
  observer(({ vm }) => {
    const payment = vm.item.originalPayment;

    return (
      <Section
        title={vm.translate("cardTransaction.title")}
        context={payment}
        headerInfo={refundPaymentProcessingInfo(vm.translateModuleGeneral)}>
        <Row>
          <Form.Group as={Col} xs={6} className="mb-3">
            <Form.Label>{vm.translateModelAttribute("payGateRefundPayment", "paidAmount")}</Form.Label>
            <FakeInput target={payment} property="paidAmount" valueFormatter={(amount: number) => formatAmount(amount)} />
          </Form.Group>
          <Form.Group as={Col} xs={6} className="mb-3">
            <Form.Label>{vm.translateModelAttribute("refundOriginalPayGatePayment", "variableSymbol")}</Form.Label>
            <FakeInput target={payment} property="variableSymbol" />
          </Form.Group>
        </Row>
        <Row>
          <Form.Group as={Col} xs={6} className="mb-3">
            <Form.Label>{vm.translateModelAttribute("payGateRefundPayment", "invoiceNumber")}</Form.Label>
            <FakeInput target={payment} property="invoiceNumber" />
          </Form.Group>
          <Form.Group as={Col} xs={6} className="mb-3">
            <Form.Label>{vm.translateModelAttribute("payGateRefundPayment", "authCode")}</Form.Label>
            <FakeInput target={payment} property="authCode" />
          </Form.Group>
        </Row>
        <Row>
          <Form.Group as={Col} xs={6} className="mb-3">
            <Form.Label>{vm.translateModelAttribute("payGateRefundPayment", "cardNumber")}</Form.Label>
            <FakeInput target={payment} property="cardNumber" />
          </Form.Group>
          <Form.Group as={Col} xs={6} className="mb-3">
            <Form.Label>{vm.translateModelAttribute("payGateRefundPayment", "authorizedAt")}</Form.Label>
            <FakeInput target={payment} property="authorizedAt" valueFormatter={(date: Date) => formatDateTime(date)} />
          </Form.Group>
        </Row>
        <Row>
          <Form.Group as={Col} xs={12} className="mb-3">
            <Form.Label>{vm.translateModelAttribute("payGateRefundPayment", "arn")}</Form.Label>
            <FakeInput target={payment} property="arn" />
          </Form.Group>
        </Row>
        <hr />
        <Row>
          <Form.Group as={Col} xs={6} className="mb-3">
            <Form.Label>{vm.translateModelAttribute("merchantBankAccount", "accountNumber")}</Form.Label>
            <FakeInput target={payment?.merchantBankAccount} property="accountNumber" />
          </Form.Group>
          <Form.Group as={Col} xs={6} className="mb-3">
            <Form.Label>{vm.translateModelAttribute("merchantBankAccount", "bank")}</Form.Label>
            <FakeInput target={payment?.merchantBankAccount} property="bank" />
          </Form.Group>
        </Row>
        <Row>
          <Form.Group as={Col} xs={6} className="mb-3">
            <Form.Label>{vm.translateModelAttribute("payGateRefundPayment", "merchantId")}</Form.Label>
            <FakeInput target={payment} property="merchantId" />
          </Form.Group>
          <Form.Group as={Col} xs={6} className="mb-3">
            <Form.Label>{vm.translateModelAttribute("payGateRefundPayment", "terminalId")}</Form.Label>
            <FakeInput target={payment} property="terminalId" />
          </Form.Group>
        </Row>
      </Section>
    );
  });

export default PayGateRefundPaymentSectionView;
